import {ChangeDetectionStrategy, Component, input, Input, output, TrackByFunction, viewChild} from '@angular/core';
import {NguCarousel, NguCarouselConfig, NguCarouselDefDirective, NguTileComponent} from '@ngu/carousel';
import {Image, WineProduct} from '@core/interfaces/generated/graphql';
import {NgOptimizedImage} from '@angular/common';
import {ProductImage} from '@modules/page/components/product/components/product-image/product-images.component';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons';
import {
  Orbitvu360Component
} from '@modules/page/components/product/components/product-image/orbitvu-360/orbitvu-360.component';
import {ArrowCircleDownIconComponent} from '@core/svg-icons/360-image-icon.component';

@Component({
  selector: 'app-product-image-carousel',
  templateUrl: './product-image-carousel.component.html',
  styleUrls: ['./product-image-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, NguTileComponent, NguCarouselDefDirective, FaIconComponent, Orbitvu360Component, NguCarousel, ArrowCircleDownIconComponent]
})
export class ProductCarouselComponent {

  images = input<ProductImage[] | null>(null);
  readonly activeImageIdChange = output<string>();
  readonly openImageModal = output();
  readonly orbitvuError = output<void>();
  readonly carousel = viewChild<NguCarousel<WineProduct['images']>>('carousel');
  public carouselTile: NguCarouselConfig = {
    grid: {
      xs: 1, sm: 1, md: 1, lg: 1, xl: 1, all: 0
    },
    slide: 1,
    speed: 350,
    point: {
      visible: true
    },
    load: 2,
    velocity: 0,
    loop: true,
    touch: false,
    easing: 'cubic-bezier(0, 0, 0.2, 1)'
  };
  protected readonly faMagnifyingGlass = faMagnifyingGlass;

  @Input()
  set activeImageId(value: string | null) {
    const images = this.images();
    const carousel = this.carousel();
    if (!images || !carousel) {
      return;
    }
    const activeImageIndex = images.findIndex(image => image?.id === value);
    if (activeImageIndex !== -1) {
      carousel.moveTo(activeImageIndex);
    }
  }

  onMove(event: NguCarousel<ProductImage, ProductImage[]>) {
    const images = this.images();
    if (!images) {
      return;
    }
    const activeImage = images[event.currentSlide];
    this.activeImageIdChange.emit(activeImage?.id ?? '');
  }

  trackBy(): TrackByFunction<Image> {
    return (index, item) => {
      return item?.id;
    };
  }
}
